module.exports = __webpack_public_path__ + "background.png?747444f0b3870a4157678a4c79ce553d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.png
// module id = 39
// module chunks = 0